import { Box } from "@mui/material"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import CheckBoxGroupField from "src/components/atom/CheckBoxGroupField"
import { OutlinedButton } from "src/components/buttons/OutlinedButton"
import { useLoginContext } from "src/hooks/useLoginContext"
import { NEWS_STATE, NEWS_MODAL_TYPE, NEWS_INTERVIEW_TYPES_STRING } from "src/modules/const"
import { PublishModal } from "./PublishModal"

interface Props {
  state: number
  type?: string
  area?: number
  isPublic?: boolean
  handlePublish?: any
  handlePrivate?: any
  handleDelete?: any
  handleSave?: any
}

export const PublishPanelItem = ({
  state,
  type,
  area,
  isPublic,
  handlePublish,
  handlePrivate,
  handleDelete,
  handleSave,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.news" })
  const { areas } = useLoginContext()

  const [category, setCategory] = useState<string>(type ? type : NEWS_INTERVIEW_TYPES_STRING.NEWS)
  const [areaID, setAreaID] = useState<number>(area ? area : 1)

  const [openModal, setOpenModal] = useState<boolean>(false)
  const [selectedModalType, setSelectedModalType] = useState<number>()

  const [areaValidationMessage, setAreaValidationMessage] = useState<string>()
  const [categoryValidationMessage, setCategoryValidationMessage] = useState<string>()

  const [publicState, setPublicState] = useState<boolean>(isPublic!)

  const handleButtonClicked = (type: number) => {
    setSelectedModalType(type)
    setOpenModal(true)
  }

  const validate = async () => {
    let ret = true

    if (category) {
      setCategoryValidationMessage("")
    } else {
      setCategoryValidationMessage(t("please_select_category"))
      ret = false
    }

    if (areaID) {
      setAreaValidationMessage("")
    } else {
      setAreaValidationMessage(t("please_select_area"))
      ret = false
    }

    return ret
  }

  const handleUpdate = async () => {
    if (!(await validate())) {
      return
    }

    handleSave(category, areaID)
  }

  const handleNewPublish = async () => {
    if (!(await validate())) {
      return
    }

    handlePublish(category, areaID)
  }

  return (
    <Box>
      <Box sx={{ ml: "30px", mt: "20px", mb: "10px" }}>
        <CheckBoxGroupField
          radio
          name={t("area")}
          nameSize={14}
          datas={areas}
          labelSize={14}
          lineSpace={0.5}
          selected={areaID}
          handleSelected={setAreaID}
          labelStyle={{ fontFamily: "Noto Sans JP !important;" }}
          validationMessage={areaValidationMessage}
        />
      </Box>
      <Box sx={{ ml: "30px", mt: "20px", mb: "10px" }}>
        <CheckBoxGroupField
          radio
          name={t("category")}
          nameSize={14}
          datas={[
            { label: t("news"), value: NEWS_INTERVIEW_TYPES_STRING.NEWS },
            { label: t("interview"), value: NEWS_INTERVIEW_TYPES_STRING.INTERVIEW },
          ]}
          labelSize={14}
          lineSpace={0.5}
          selected={category}
          handleSelected={setCategory}
          labelStyle={{ fontFamily: "Noto Sans JP !important;" }}
          validationMessage={categoryValidationMessage}
        />
      </Box>
      {state == NEWS_STATE.CREATE && (
        <>
          <OutlinedButton
            className="notosans"
            caption={t("post_publish")}
            onClick={handleNewPublish}
            sx={{
              width: "170px",
              height: "34px",
              ml: "20px",
              my: "5px",
              color: "primaryMain",
              borderColor: "#1F6757",
            }}
            fontColor="primary.main"
            fontWeight="700"
          />
        </>
      )}
      {state == NEWS_STATE.EDIT && (
        <>
          <OutlinedButton
            className="notosans"
            caption={t("save")}
            onClick={handleUpdate}
            sx={{
              width: "170px",
              height: "34px",
              ml: "20px",
              my: "5px",
              color: "#1F6757",
              borderColor: "#1F6757",
            }}
            fontColor="#1F6757"
            fontWeight="700"
          />
          {publicState ? (
            <OutlinedButton
              className="notosans"
              caption={t("private")}
              onClick={() => handleButtonClicked(NEWS_MODAL_TYPE.PRIVATE)}
              sx={{
                width: "170px",
                height: "34px",
                ml: "20px",
                my: "5px",
                color: "#FFB800",
                borderColor: "#FFB800",
              }}
              fontColor="#FFB800"
              fontWeight="700"
            />
          ) : (
            <OutlinedButton
              className="notosans"
              caption={t("public")}
              onClick={() => handleButtonClicked(NEWS_MODAL_TYPE.PRIVATE)}
              sx={{
                width: "170px",
                height: "34px",
                ml: "20px",
                my: "5px",
                color: "#1F6757",
                borderColor: "#1F6757",
              }}
              fontColor="#1F6757"
              fontWeight="700"
            />
          )}
          <OutlinedButton
            className="notosans"
            caption={t("delete")}
            onClick={() => handleButtonClicked(NEWS_MODAL_TYPE.DELETE)}
            sx={{
              width: "170px",
              height: "34px",
              ml: "20px",
              my: "5px",
              color: "#FC3317",
              borderColor: "#FC3317",
            }}
            fontColor="#FC3317"
            fontWeight="700"
          />
        </>
      )}

      <PublishModal
        open={openModal}
        id={1}
        type={selectedModalType}
        category={category}
        area={areaID}
        isPublic={publicState}
        handleOpen={setOpenModal}
        handlePublish={handlePublish}
        handlePrivate={handlePrivate}
        handleDelete={handleDelete}
        handleSave={handleSave}
        handlePublicState={setPublicState}
      />
    </Box>
  )
}
